<div
  class="rounded-2xl bg-white p-1 2xsm:p-2 pt-4 shadow-theme-xs border border-gray-200">

  <!--! header -->
  <div class="mb-6 flex items-center justify-between px-2 pt-2">
    <button
      (click)="requestPrevMonth()"
      [disabled]="!canGoPrev()"
      class="flex h-10 w-10 items-center justify-center rounded-lg border border-gray-300 bg-white shadow-theme-md transition-all hover:bg-gray-50 disabled:opacity-20 disabled:cursor-not-allowed"
    >
      <lib-icon name="long-arrow-left" class="size-5 text-gray-700"></lib-icon>
    </button>
    <div class="text-center">
      <h3 class="text-center font-title text-theme-sm font-medium text-gray-700">
        {{ currentMonthName() }}
      </h3>
      <p class="mt-0.5 text-center font-title text-theme-xs font-normal text-gray-700">
        {{ currentYear() }}
      </p>
    </div>

    <button
      (click)="requestNextMonth()"
      [disabled]="!canGoNext()"
      class="flex h-10 w-10 items-center justify-center rounded-lg border border-gray-300 bg-white shadow-theme-md transition-all hover:bg-gray-50 disabled:opacity-20 disabled:cursor-not-allowed"
    >
      <lib-icon name="long-arrow-right" class="size-5 text-gray-700"></lib-icon>
    </button>
  </div>

  <!--! grid calendari -->
  <div class="w-full overflow-hidden">
    <!--@ dies -->
    <div class="flex flex-col cursor-pointer">
      <div class="grid grid-cols-7">
        @for (emptyDay of previousMonthEmptySpaces(); track $index) {
          
          <div 
            class="relative h-14 flex items-center justify-center py-2 transition-colors last:border-r-0" >
          </div>
        }

        @for ( date of monthDates; track date) {
          @if(isCurrentMonth(date) && controlFor(date)){
            <lib-schedule-calendar-day-edit [day]="formatDate(date)" [control]="controlFor(date)"/>
          }@else {
            
          <div>
            <div 
              class="relative flex items-center justify-center py-2 px-3 transition-colors last:border-r-0 z-20 border-t border-t-gray-200 border-b border-b-gray-50 font-title text-xs leading-[18px] font-medium" 
              >
                {{ getDateDay(date) }}
            </div>
            <div 
              class="relative flex items-center justify-center transition-colors px-2 py-3.5 z-10" >
              <div class="w-full h-7 animate-pulse bg-gray-300 rounded-xl"></div>
            </div>
          </div>
          }
        }
      </div>
    </div>
  </div>
</div>
